import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const backgroundAssetStyles = {
  backgroundAsset: (): SystemStyleObject<Theme> => ({
    position: "absolute",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
  }),
};

export default backgroundAssetStyles;
